"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _ToggleButtonsGroup = _interopRequireDefault(require("../../../ToggleButtonsGroup"));
var _constants = require("../../../../constants");
var _excluded = ["value", "onChange"];
var DEFAULT_RELATION = _constants.LOG_RELATIONS.TICKET;
var relationValues = Object.values(_constants.LOG_RELATIONS);
var labels = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.LOG_RELATIONS.CLIENT, 'Лог клиента'), _constants.LOG_RELATIONS.TICKET, 'Лог тикета');
var StyledButton = _ToggleButtonsGroup["default"].StyledButton;
var LogRelations = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledLogRelations, rest, /*#__PURE__*/_react["default"].createElement(StyledTogglers, {
    required: true,
    values: [value],
    onChange: onChange
  }, relationValues.map(function (relation) {
    return /*#__PURE__*/_react["default"].createElement(StyledToggleButton, {
      key: relation,
      value: relation,
      checked: value
    }, labels[relation]);
  })));
});
LogRelations.displayName = 'LogRelations';
LogRelations.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].oneOf(relationValues),
  onChange: _propTypes["default"].func
};
LogRelations.defaultProps = {
  className: '',
  value: DEFAULT_RELATION,
  onChange: Function.prototype
};
var StyledLogRelations = _styledComponents["default"].div.withConfig({
  displayName: "LogRelations__StyledLogRelations",
  componentId: "sc-xqzbhv-0"
})(["min-width:250px;"]);
var StyledTogglers = (0, _styledComponents["default"])(_ToggleButtonsGroup["default"]).withConfig({
  displayName: "LogRelations__StyledTogglers",
  componentId: "sc-xqzbhv-1"
})(["background-color:#f5f3f2;border-radius:4px;display:flex;height:auto;", "{flex:1;border:4px solid #f5f3f2;border-radius:4px;line-height:32px;&:first-child{border-left:4px solid #f5f3f2;border-right:none;border-radius:4px;}&:last-child{border-left:none;border-right:4px solid #f5f3f2;border-radius:4px;}}"], StyledButton);
var StyledToggleButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "LogRelations__StyledToggleButton",
  componentId: "sc-xqzbhv-2"
})(["background:transparent;", ""], function (props) {
  return props.checked && "\n    background: white;\n  ";
});
var _default = exports["default"] = LogRelations;